export const copy = (startOfNextCycle?: string, showJoinExistingPlan?: boolean) => {
  const nextCycleString = startOfNextCycle ? ` (starting ${startOfNextCycle}).` : ".";
  return {
    TrialExpired_FlexMeeting: {
      header: "Your 30-day Teams trial has expired",
      button: showJoinExistingPlan ? "Join a Plan" : "Upgrade",
      text: "Please upgrade to keep your flexible meeting.",
      showContactUs: false,
    },
    TrialOverExpired_FlexMeeting: {
      header: "You are on the Free plan.",
      button: showJoinExistingPlan ? "Join a Plan" : "Upgrade",
      text: "Please upgrade to keep your flexible meeting.",
      showContactUs: false,
    },
    TrialExpired_Sidebar: {
      header: "Your 30-day Teams trial has expired",
      button: showJoinExistingPlan ? "Join a Plan" : "Upgrade",
      text:
        "Clockwise will stop moving your flexible meetings and scheduling Focus Time holds for you.",
      showContactUs: true,
    },
    TrialOneDayLeft_FocusTime: {
      header: "Teams trial expires in 1 day",
      button: showJoinExistingPlan ? "Join a Plan" : "Upgrade",
      text:
        "Clockwise will stop scheduling Focus Time holds on your calendar. Upgrade now to keep your Focus Time holds.",
      showContactUs: false,
    },
    TrialOneDayLeft_FlexMeeting: {
      header: "Teams trial expires in 1 day",
      button: showJoinExistingPlan ? "Join a Plan" : "Upgrade",
      text: "Clockwise will stop moving this event. Upgrade now to keep this flexible meeting.",
      showContactUs: false,
    },
    QuotaExceeded: {
      header: "Free quota exceeded",
      button: showJoinExistingPlan ? "Join a Plan" : "View Plans",
      text: `Clockwise will stop scheduling and rescheduling events automatically until the next cycle${nextCycleString}`,
      showContactUs: true,
    },
  };
};
